/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteMediaPartner} from '../api'

export const useMutationDeleteMediaPartner = createReactQueryMutationHook('deleteMediaPartner', deleteMediaPartner)
